import { useApi } from '@repo-level/core-front';
import type { BrandAssets } from 'api/cms/brandAssets';
import { brandAssets } from 'api/cms/brandAssets';

import { useAuthCookies } from 'hooks/authCookies';
import type { FC } from 'react';
import { createContext, useEffect } from 'react';

export interface CommonUtilsContextData {
  brandAssetsData?: BrandAssets;
  isLiveSpinsAvailable: boolean;
}

export const CommonUtilsContext = createContext<CommonUtilsContextData>(
  null as any
);

export const CommonUtilsContextProvider: FC = ({ children }) => {
  useAuthCookies();

  const isLiveSpinsAvailable = false;

  const [requestBrandAssets, { data: brandAssetsData }] = useApi(brandAssets);

  useEffect(() => {
    requestBrandAssets();
  }, [requestBrandAssets]);

  return (
    <CommonUtilsContext.Provider
      value={{
        brandAssetsData,
        isLiveSpinsAvailable,
      }}
    >
      {children}
    </CommonUtilsContext.Provider>
  );
};
